import { useEffect, useState } from "react";
import styles from "./carousel.module.less";
import useEmblaCarousel from "embla-carousel-react";
import { EmblaCarouselType } from "embla-carousel";
import { OutlineIconButton } from "../button/button";
import { useTranslation } from "react-i18next";

type TCarouselProps = {
  heading?: string;
  items: Array<any>;
  wrapperClassName?: string;
};

export const Carousel = ({ heading, items, wrapperClassName }: TCarouselProps) => {
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    slidesToScroll: "auto",
    align: "start",
  });

  const onSelect = (emblaApi: EmblaCarouselType) => {
    if (!emblaApi) {
      return;
    }

    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  };

  useEffect(() => {
    if (!emblaApi) {
      return;
    }

    onSelect(emblaApi);
    emblaApi?.on("reInit", onSelect);
    emblaApi?.on("select", onSelect);

    return () => {
      emblaApi?.off("select", onSelect);
    };
  }, [emblaApi, onSelect]);

  const { t } = useTranslation();

  const otherSlidesToShow = canScrollPrev || canScrollNext;

  return (
    <div className={[styles.wrapper, wrapperClassName ? wrapperClassName : ""].join(" ")}>
      {heading && <h2>{heading}</h2>}
      <div className={"embla"}>
        <div ref={emblaRef} className="embla__viewport">
          <ul className={[styles.slider, "embla__container", !otherSlidesToShow ? styles.hidePeek : ""].join(" ")}>
            {items.map((item, index) => {
              return (
                <li key={index} className={["embla__slide", styles.slide].join(" ")}>
                  {item}
                </li>
              );
            })}
          </ul>
        </div>
        {otherSlidesToShow && (
          <div className={styles.navigation}>
            <OutlineIconButton
              isDisabled={!canScrollPrev}
              icon={"ui-icon-arrow-left"}
              onClick={() => emblaApi?.scrollPrev()}
              ariaLabel={t("PREVIOUS_PAGE")}
            />
            <OutlineIconButton
              isDisabled={!canScrollNext}
              icon={"ui-icon-arrow-right"}
              onClick={() => emblaApi?.scrollNext()}
              ariaLabel={t("NEXT_PAGE")}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Carousel;
